import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { CollectionPeriod } from '../collection-period.model';

@JsonObject('CollectionsPeriodsResultsResponse')
export class CollectionsPeriodsResultsResponse extends ApiResultsResponse<CollectionPeriod> {

  @JsonProperty('results', [CollectionPeriod])
  override results: CollectionPeriod[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
